/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {

} from 'state/actions/overlay_status';



/* ========== ~~~~~~~~~~  OVERLAY STATUS : REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components
const overlayStatus = (state = defaultState, action) => {
    switch (action.type) {

        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default overlayStatus;